import { h, Component } from 'preact';
import { joinClasses, sortObjectByOrder } from 'utils/utils';
import { useDynamicAssetFolder } from 'utils/assets';
import PlaylistItem from 'components/shared/playlist/playlistItem';
import ScrollBox from 'components/shared/scrollBox/scrollBox';
// import { Link } from 'components/core/link/link.js';
import s from 'components/shared/playlist/playlist.sss';


export default class Playlist extends Component {

	doScroll(dir) {
		if (!this.$scroller || !this.$scroller.addForce) return;
		this.$scroller.addForce(dir * this.$scroller.base.clientWidth / 20);
	}

	render() {
		const {
			device, // Which device is being used (comes from store)
			list, // Actual list of items displayed
			copy,
			isOpen,
			playlistClass, // Class for the playlist (not the whole container, doesnt include the toggle)
			onPlaylistItemClick = () => {}, // Update the item thats active,
			activeItem, // the current active item
			showButtons, // Boolean saying if it should show the buttons
			buttonActions, // Actions for the buttons
			playlistId = '', // Not required, useful for adding specific styling
			alt
		} = this.props;

		let {
			buttonClasses // Classes for the buttons
		} = this.props;

		let playlistItems = list;

		if (!Array.isArray(playlistItems)) {
			// Make sure it's an array
			playlistItems = sortObjectByOrder(playlistItems);
		}
		// playlistItems = playlistItems.map((item, i) => {item.index = i});


		const playList = playlistItems.filter(item => item && !!item.thumbSrc).map(item => {
			// const extendedItem = {...item, index: i}
			return	(
				<PlaylistItem
					key={useDynamicAssetFolder(item.thumbSrc)}
					copy={copy}
					playlistId={playlistId}
					active={item === activeItem}
					item={item}
					onSelect={onPlaylistItemClick}
					isOpen={isOpen}
					alt={alt}
				/>
			);
		});
		let buttons = null;

		if (showButtons) {
			let actionLeft = this.doScroll.bind(this, -1);
			let actionRight = this.doScroll.bind(this, 1);

			if (buttonActions) {
				if (buttonActions.left) actionLeft = buttonActions.left;
				if (buttonActions.right) actionRight = buttonActions.right;
			}

			let classLeft = s.scrollLeft;
			let classRight = s.scrollRight;

			if (buttonClasses) {
				if (typeof buttonClasses === 'string') {
					buttonClasses = {
						left: buttonClasses,
						right: buttonClasses
					};
				}

				if (buttonClasses.left) classLeft += ' ' + buttonClasses.left;
				if (buttonClasses.right) classRight += ' ' + buttonClasses.right;
			}

			buttons = [
				(<div class={classLeft} onclick={actionLeft} />),
				(<div class={classRight} onclick={actionRight} />)
			];
		}

		return (
			<div class={joinClasses(s.base, playlistClass, s[playlistId + 'Container'], isOpen && s.isOpen)}>
				<ScrollBox
					class={s.scrollBox}
					device={device}
					scrollableLeftClass={s.showLeft}
					scrollableRightClass={s.showRight}
					ref={$ref => $ref && (this.$scroller = $ref)}
				>
					<ul class={s.wrapper}>
						{playList}
					</ul>
				</ScrollBox>
				{buttons}
			</div>
		);
	}

}
